<template>
  <v-row>
    <v-col cols=12>
      <span class="title">Puhelun tila</span>
    </v-col>
    <template v-if="graphData">
      <v-col cols=12>
        <v-btn
          depressed
          color="blue"
          @click="toggleChartDistribution"
          class="mr-4"
        >
          {{distribution}}
        </v-btn>
      </v-col>
      <v-col cols=12>
        <canvas
          ref="graph"
          height="300px"
          width="1000px"
        >
        </canvas>
      </v-col>
      <v-col cols=12>
        <hr>
        <span class="title">Omainen</span>
      </v-col>
      <v-col cols=12 class="graph-container">
        <BitrateChart :graphData="kitBitrate" v-if="kitBitrate && kitBitrate.length > 0"/>
      </v-col>
      <v-col cols=12 class="graph-container">
        <FpsChart :graphData="kitFps" v-if="kitFps && kitFps.length > 0"/>
      </v-col>
      <v-col cols=12 class="graph-container">
        <ResolutionChart :graphData="kitRes" v-if="kitRes && kitRes.length > 0"/>
      </v-col>
      <v-col cols=12>
        <hr>
        <span class="title">Hoivakoti</span>
      </v-col>
      <v-col cols=12 class="graph-container">
        <BitrateChart :graphData="hostBitrate" v-if="hostBitrate && hostBitrate.length > 0"/>
      </v-col>
      <v-col cols=12 class="graph-container">
        <FpsChart :graphData="hostFps" v-if="hostFps && hostFps.length > 0"/>
      </v-col>
      <v-col cols=12 class="graph-container">
        <ResolutionChart :graphData="hostRes" v-if="hostRes && hostRes.length > 0"/>
      </v-col>
      <v-col cols=12>
        <hr>
        <span class="title">Kamera</span>
      </v-col>
      <v-col cols=12 class="graph-container">
        <BitrateChart :graphData="cameraBitrate" v-if="cameraBitrate && cameraBitrate.length > 0"/>
      </v-col>
      <v-col cols=12 class="graph-container">
        <FpsChart :graphData="cameraFps" v-if="cameraFps && cameraFps.length > 0"/>
      </v-col>
      <v-col cols=12 class="graph-container">
        <ResolutionChart :graphData="cameraRes" v-if="cameraRes && cameraRes.length > 0"/>
      </v-col>
    </template>
    <v-col v-if="state === 'ERROR'">
      <span class="red--text">{{error}}</span>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */
import Chart from 'chart.js';
import { idToken } from '@/utils/auth';
import EventBus from '@/utils/EventBus';

import BitrateChart from './bitrateChart.vue';
import FpsChart from './fpsChart.vue';
import ResolutionChart from './resolutionChart.vue';

export default {
  props: {
    region: {
      type: String,
      required: true,
    },
    callId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      distribution: 'series',
      headers: [
        { text: 'Device', align: 'start', sortable: true, value: 'name' },
        { text: 'width', value: 'width' },
        { text: 'height', value: 'height' },
        { text: 'FPS', value: 'fps' },
        { text: 'bitrate', value: 'bitrate' },
        { text: 'Timestamp', value: 'timestamp' },
      ],
      chartUI: null,
      colors: [
        'cyan',
        'orange',
        'magenta',
        'purple',
      ],
      videocallEventTypes: [
        'initialize',
        'ready',
        'calling',
        'ringing',
        'noanswer',
        'incall',
        'joined',
        'left',
        'hangup',
        'error',
        'volume',
        'fullscreen_source',
        'speedtest',
        'quality_user',
        'cam360_view_type',
        'cam360_view_direction',
        'cam360_view_fov',
        'quality_output_video_stream',
      ],
      graphData: null,
      tableData: [],
      qualityData: null,
      hostRes: null,
      hostFps: null,
      hostBitrate: null,
      kitRes: null,
      kitFps: null,
      kitBitrate: null,
      cameraRes: null,
      cameraFps: null,
      cameraBitrate: null,
      config: null,
      state: null,
    };
  },
  components: {
    BitrateChart,
    FpsChart,
    ResolutionChart,
  },
  created() {
    EventBus.$on('callId-changed', this.changeHandler);
  },
  mounted() {
    console.log('mounted');
    this.initialize();
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    EventBus.$off('callId-changed', this.changeHandler);
    if (this.chartUI) {
      this.chartUI.destroy();
    }
  },
  methods: {
    changeHandler(id) {
      console.log('changeHandler');
      if (id === this.callId && this.graphData) {
        console.log('recreating chart');
        // this.initialize();
        this.chartUI.update();
      }
    },
    toggleChartDistribution() {
      this.distribution = this.distribution === 'series' ? 'linear' : 'series';

      // update config
      this.config.options.scales.xAxes[0].distribution = this.distribution;
      this.chartUI.update();
    },
    async initialize() {
      // Fetch call events
      await this.fetchEvents();

      // set tableData
      if (this.graphData) {
        const data = this.graphData.filter((el) => el.type === 'quality_output_video_stream');
        data.sort((a, b) => (new Date(b.timestamp) - new Date(a.timestamp)));
        this.tableData = data;

        this.hostRes = data.filter(({name, ...rest}) => name === 'Hoivakoti').map(({width, height, timestamp, ...rest}) => ({ width, height, timestamp }));
        this.hostFps = data.filter(({name, ...rest}) => name === 'Hoivakoti').map(({fps, timestamp, ...rest}) => ({ fps, timestamp }));
        this.hostBitrate = data.filter(({name, ...rest}) => name === 'Hoivakoti').map(({bitrate, timestamp, ...rest}) => ({ bitrate, timestamp }));

        this.kitRes = data.filter(({name, ...rest}) => name === 'Omainen').map(({width, height, timestamp, ...rest}) => ({ width, height, timestamp }));
        this.kitFps = data.filter(({name, ...rest}) => name === 'Omainen').map(({fps, timestamp, ...rest}) => ({ fps, timestamp }));
        this.kitBitrate = data.filter(({name, ...rest}) => name === 'Omainen').map(({bitrate, timestamp, ...rest}) => ({ bitrate, timestamp }));

        this.cameraRes = data.filter(({name, ...rest}) => name === '360 kamera').map(({width, height, timestamp, ...rest}) => ({ width, height, timestamp }));
        this.cameraFps = data.filter(({name, ...rest}) => name === '360 kamera').map(({fps, timestamp, ...rest}) => ({ fps, timestamp }));
        this.cameraBitrate = data.filter(({name, ...rest}) => name === '360 kamera').map(({bitrate, timestamp, ...rest}) => ({ bitrate, timestamp }));

        const result = data.reduce((r, o) => {
            const k = o.name;
            if (r[k] || (r[k]=[])) r[k].push(o);
            return r;
          }, {});

        this.qualityData = result;

        // create chart UI
        this.createChart();
      }
    },
    async fetchEvents() {
      try {
        const token = await idToken();
        const response = await fetch(`https://rest.boom.livesynccloud.com/api/videocalls/${this.region}/${this.callId}`, {
          method: 'get',
          mode: 'cors',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log(response);
        // Check HTTP status
        if (!response.ok) {
          this.state = 'ERROR';
          this.error = `Puhelutapahtumien haku epäonnistui: ${this.callId}`;
          return;
        }

        this.state = null;
        this.error = null;

        this.graphData = await response.json();
      } catch (error) {
        console.log(error);
        this.state = 'ERROR';
        this.error = `Puhelutapahtumien haku epäonnistui: ${this.callId}`;
        this.graphData = null;
      }
    },
    createChart() {
        // create chartjs UI
        this.config = {
          type: 'line',
          data: {
            datasets: []
          },
          options: {
            responsive: true,
            // maintainAspectRatio: false,
            scales: {
              xAxes: [{
                type: 'time',
                display: true,
                distribution: this.distribution,
                gridLines: {
                  color: 'rgba(150, 150, 150, 0.5)',
                  display: false,
                },
                ticks: {
                  source: 'data',
                },
                time: {
                  displayFormats: {
                    second: 'h:mm:ss',
                    minute: 'HH:mm:ss',
                  },
                  round: 'second',
                  unit: 'minute',
                }
              }],
              yAxes: [{
                display: true,
                padding: 0,
                beginAtZero: true,
                ticks: {
                  callback: (value, index, values) => {
                    return this.videocallEventTypes[value];
                  }
                },
                gridLines: {
                  display: false,
                  color: 'rgba(150, 150, 150, 0.5)'
                },
              }]
            }
          }
        };
        // Map different device ID events to separate arrays
        var result = this.graphData.reduce((r, o) => {
          var k = o.name;
          if (r[k] || (r[k]=[])) r[k].push({ x: new Date(o.timestamp), y: this.videocallEventTypes.indexOf(o.type)});
          return r;
        }, {});

        let color = 0;
        for (let [key, value] of Object.entries(result)) {
          // Filter values to show only first 10 states
          const vals = value.filter((el) => el.y <= 9);

          // Add data to chart config
          this.config.data.datasets.push(
            {
              label: `${key}`,
              borderColor: this.colors[color],
              backgroundColor: this.colors[color],
              fill: false,
              steppedLine: true,
              data: vals,
            }
          );
          color += 1;
        }

        const chart = this.$refs.graph;
        this.chartUI = new Chart(chart, this.config);
    },
  },
};
</script>

<style scoped>
/*
.graph-container {
  margin: auto;
  position: relative;
  height: 300px;
  height: 100% !important;
  border: 1px dotted blue;
  overflow: hidden;
  min-width: 0;
}

canvas {
  border: 1px dotted red;
  width: 100%;
}

.graph-col {
  overflow: hidden;
}
*/
</style>
